import React from 'react';
import { PlayerState, GamePhase } from '@push.io/shared';
import type { MenuLanguage } from './main-menu/types.js';
import './hud.css';

interface HUDProps {
  localPlayer: PlayerState | null;
  phase: GamePhase;
  countdownSeconds: number;
  onLeave?: () => void;
  language?: MenuLanguage;
}

export function HUD({
  phase, countdownSeconds, onLeave, language,
}: HUDProps) {
  const styles: Record<string, React.CSSProperties> = {
    container: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      padding: '16px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      fontFamily: 'monospace',
      color: '#fff',
      pointerEvents: 'none',
    },
  };

  const isCountdown = phase === 'countdown' && countdownSeconds > 0;
  const tr = (es: string, en: string, fr: string) =>
    language === 'es' ? es : language === 'fr' ? fr : en;

  return (
    <div style={styles.container}>
      {onLeave && (
        <button
          type="button"
          className="hud-leave"
          onClick={onLeave}
          aria-label={tr('Abandonar partida', 'Leave match', 'Quitter la partie')}
        >
          <span className="hud-leave__x" aria-hidden="true">✕</span>
          {tr('Abandonar', 'Leave', 'Quitter')}
        </button>
      )}
      {isCountdown && (
        <div style={{
          position: 'absolute', top: '58%', left: '50%', transform: 'translate(-50%, -50%)',
          fontSize: '72px', fontWeight: 'bold', color: '#ffffff',
          fontFamily: 'monospace', textShadow: '0 0 20px rgba(68,68,255,0.8)',
        }}>
          {countdownSeconds}
        </div>
      )}
    </div>
  );
}